module.exports = __webpack_public_path__ + "img/project-pic6.65228d13.png";